import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { buildResources } from './resources';
import { DEFAULT_LANGUAGE, LANGUAGE_CODES } from './locales';

/**
 * Setup i18n (Fase 0 — infrastruttura). Rilevamento lingua: prima
 * localStorage (scelta utente), poi il browser; fallback italiano. La
 * preferenza è salvata in localStorage (`manteco.lang`); il salvataggio
 * sull'account utente è una fase successiva.
 */
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: buildResources(),
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: LANGUAGE_CODES,
    nonExplicitSupportedLngs: true, // es. 'en-US' → 'en'
    defaultNS: 'common',
    ns: ['common'],
    keySeparator: false, // chiavi flat tipo 'auth.login.title'
    nsSeparator: false,
    interpolation: { escapeValue: false }, // React già fa l'escape
    returnNull: false,
    detection: {
      // Solo localStorage (scelta esplicita dell'utente): in Fase 0 poche
      // stringhe sono tradotte, quindi NON auto-rileviamo dal browser per
      // evitare un'app mezza-italiana-mezza-altro. Riattiveremo 'navigator'
      // quando la copertura traduzioni sarà ampia.
      order: ['localStorage'],
      lookupLocalStorage: 'manteco.lang',
      caches: ['localStorage'],
    },
  });

// Mantieni <html lang> allineato (accessibilità + PWA).
function syncHtmlLang(lng: string) {
  if (lng) document.documentElement.lang = lng;
}
syncHtmlLang(i18n.resolvedLanguage || DEFAULT_LANGUAGE);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
